import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Calendar, Spin } from "antd";
import BarChart from "../../components/charts/BarChart.jsx";
import { GetEmployeeDashboardApi } from "../../api/request/dashboard/dashboard.js";
import moment from "moment";

export default function EmployeeDashboard() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const [taskData, setTaskData] = useState({});

  const [dashboardCards, setDashboardCards] = useState([
    { title: "Active Task", total: "00", icon: "/assets/icons/active-task.svg", bgColor: "#DDF6E8", path: "/report/active_job" },
    { title: "Overdue Task", total: "00", icon: "/assets/icons/overdue-task.svg", bgColor: "#FBEAEA", path: "/report/overdue_task" },
    { title: "Total Task", total: "00", icon: "/assets/icons/total-task.svg", bgColor: "#E9E7FD", path: "/organizers" },
  ]);

  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue("--primary")?.trim();
  const secondary = getComputedStyle(document.documentElement).getPropertyValue("--secondaryLight1")?.trim();

  const getDashboard = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetEmployeeDashboardApi();
      if (data?.status) {
        setData(data?.data);

        const updatedTotals = [data?.data?.active_task, data?.data?.over_due_task, data?.data?.total_task];
        setDashboardCards(dashboardCards.map((card, index) => ({ ...card, total: updatedTotals[index] })));

        let completedTask = [];
        let pendingTask = [];
        let days = [];
        data?.data?.chart_data?.map((item) => {
          completedTask?.push(item?.completed_tasks);
          pendingTask?.push(item?.running_tasks);
          days?.push(`${moment(item?.date).format("MMM DD")}`);
        });
        setTaskData({
          categories: days,
          series: [
            { name: "Completed", data: completedTask },
            { name: "Pending", data: pendingTask, prefix: "", postfix: "" },
          ],
        });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getDashboard();
  }, []);

  const onPanelChange = (value, mode) => {
    console.log(value.format("YYYY-MM-DD"), mode);
  };

  return (
    <div>
      {isLoading ? (
        <div className="flex justify-center flex-col mt-[20%]">
          <Spin size="large" />
          <p className="primary text-center mt-2">Loading...</p>
        </div>
      ) : (
        <>
          <div className="grid sm:grid-cols-3 gap-5">
            {dashboardCards.map((item, index) => (
              <div key={index} className="border-2 rounded-xl p-4 cursor-pointer" onClick={() => navigate(item?.path)}>
                <div className="flex justify-between items-center">
                  <div>
                    <p className="font-medium">{item.title}</p>
                    <p className="font-semibold text-2xl mt-2">{item.total}</p>
                  </div>
                  <div className="rounded-xl size-14 flex items-center justify-center" style={{ backgroundColor: item.bgColor }}>
                    <img src={item.icon} alt="icon" />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="grid sm:grid-cols-4 gap-5 mt-5">
            <div className="sm:col-span-3 border-2 rounded-xl">
              <div className="flex justify-end mt-5 mx-5">
                <div className="flex items-center gap-6">
                  <div className="flex items-center gap-3">
                    <div className="size-4 bg-secondaryLight1 rounded-full"></div>
                    <p className="text-secondaryLight1">Completed</p>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="size-4 bg-primary rounded-full"></div>
                    <p className="text-secondaryLight1">Pending</p>
                  </div>
                </div>
              </div>
              <BarChart data={taskData} colors={[secondary, primaryColor]} />
            </div>
            <div className="flex flex-col justify-between gap-5">
              <div className="flex justify-center items-center rounded-xl bg-[#FFF0E6]">
                <div className="text-center my-7">
                  <p className="text-2xl font-bold">{data?.client_delay}</p>
                  <p className="font-semibold">Client Delay</p>
                </div>
              </div>
              <div className="flex justify-center items-center rounded-xl bg-[#ECEAFE]">
                <div className="text-center my-7">
                  <p className="text-2xl font-bold">{data?.no_responce}</p>
                  <p className="font-semibold">No Response</p>
                </div>
              </div>
              <div className="flex justify-center items-center rounded-xl bg-[#E5F7FF]">
                <div className="text-center my-7">
                  <p className="text-2xl font-bold">{data?.doc_not_ready}</p>
                  <p className="font-semibold">Document Not Ready</p>
                </div>
              </div>
            </div>
          </div>
          <div className="border-2 rounded-xl my-5 p-2">
            <Calendar onPanelChange={onPanelChange} />
          </div>
        </>
      )}
    </div>
  );
}
